import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Divider } from 'antd';
import SecLogo from '../../../../utility/unnamed.png';

export default function SuccessfullyEnrolled() {
  const navigate = useNavigate();

  return (
    <div className="flex justify-center px-4 py-10 relative min-h-screen bg-gradient-to-br from-green-50 to-green-100 items-center overflow-hidden">
      {/* Matching Background Floating Circles */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-green-200 rounded-full animate-bounce opacity-30" />
      <div className="absolute bottom-20 right-20 w-24 h-24 bg-green-300 rounded-full animate-pulse opacity-20" />
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-green-100 rounded-full animate-spin-slow opacity-25" />

      {/* Main Content Card Container */}
      <div className="w-full max-w-2xl bg-white rounded-lg shadow-md p-8 text-center">
        
        {/* Unified App Header */}
        <header className="flex flex-col items-center mb-6 border-b border-gray-200 pb-4">
          <img 
            src={SecLogo} 
            alt="SEC Logo" 
            className="w-80 h-68 mb-4 pointer-events-none select-none" 
          />
          <h1 className="text-lg font-bold text-[#004830] text-center">
            Electronic Filing and Submission Tool (eFAST)
          </h1>
          <p className="text-[#004830] text-sm text-center mt-1">
            Formerly known as Online Submission Tool (OST)
          </p>
        </header>

        {/* Success Announcement Header */}
        <div className="my-6">
          <h2 className="text-2xl font-bold text-emerald-700 mb-2">
            Congratulations!
          </h2>
          <h3 className="text-lg text-slate-700 font-medium">
            You have been Successfully Enrolled.
          </h3>
        </div>
        
        <Divider style={{ margin: '24px 0' }} />

        {/* Informative Body Box */}
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-5 my-6 max-w-xl mx-auto">
          <p className="text-slate-600 text-sm leading-relaxed mb-0" style={{ fontStyle: "italic" }}>
            A validation email will be sent to your official email address. 
            Please check your inbox and validate your account using the provided link to complete your setup.
          </p>
        </div>

        <Divider style={{ margin: '24px 0' }} />

        {/* Navigation Action Footer */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-6">
          <Button
            type="primary"
            size="large"
            onClick={() => navigate('/user/login')}
            className="!bg-[#004830] hover:!bg-[#003322] px-8 font-medium w-full sm:w-auto"
          >
            Back to Login
          </Button>
        </div>
        
        <p className="mt-6 text-xs text-slate-400">
          Securities and Exchange Commission © All Rights Reserved.
        </p>
      </div>
    </div>
  );
}